// extracted by mini-css-extract-plugin
module.exports = {"delay":"delay-56b5b7582fee7ec693196f667308096a"};